import { Popover as BasePopover } from "@base-ui/react/popover";
import type { ComponentProps } from "react";
import { cn } from "../utils";

export const Popover = BasePopover.Root;
export const PopoverTrigger = BasePopover.Trigger;

export function PopoverContent({
  className,
  children,
  align = "start",
  side,
  ...props
}: ComponentProps<typeof BasePopover.Popup> & {
  align?: "start" | "center" | "end";
  side?: "top" | "bottom" | "left" | "right";
}) {
  return (
    <BasePopover.Portal>
      <BasePopover.Positioner
        sideOffset={4}
        side={side}
        align={align}
        className="z-50 outline-none"
      >
        <BasePopover.Popup
          className={cn(
            "rounded-surface border border-line bg-surface-overlay p-3 shadow-overlay",
            "origin-[var(--transform-origin)] transition-[transform,opacity] duration-150 ease-swift",
            "data-[starting-style]:scale-95 data-[starting-style]:opacity-0",
            "data-[ending-style]:scale-95 data-[ending-style]:opacity-0",
            className,
          )}
          {...props}
        >
          {children}
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </BasePopover.Portal>
  );
}
